module.exports = __webpack_public_path__ + "img/introduction-mini.8d4243fa.png";